import * as MODULES from '../module-codes'
import axios from 'axios'

export const state = () => ({
    employees: [],
})

export const getters = {
}

export const actions = {
    populateFromDB: async ({ commit }) => {
        axios.post('/api/pcs/teamProfile', {
            params: {
                pcs: localStorage.getItem('pcs')
            }
        }).then(res => {
            commit("SET_TEAM_PROFILE_MODULE_DATA", res.data['settings'])
        })
    },
}

export const mutations = {
    SET_TEAM_PROFILE_MODULE_DATA(state, payload) {
        state.employees = payload.employees
    },
    CLEAR_STATE: state => {
        state.employees = []
      },
}